export const enum AppPlaceholderEventType {
  AddFlight = 'addFlight',
  AddFerry = 'addFerry',
  AddHotel = 'addHotel',
  AddActivity = 'addActivity',
}
